import { gql } from 'apollo-angular';

const SUBMIT_OFFERS = gql`
  mutation submitOffers($input: SubmitOffersRequest!) {
    submitOffers(input: $input) {
      success
    }
  }
`;

export default SUBMIT_OFFERS;
